// Lightweight helper for investment proof uploads and review (Cloudflare R2 storage)

import { payrollService } from "./api";

export async function uploadFileToR2(file, options = {}) {
  const data = await payrollService.uploadProof(file, options);
  return data?.data ?? data; // keep existing callers working
}

export async function createInvestmentAttachment(declarationId, payload) {
  const data = await payrollService.createInvestmentAttachment(
    declarationId,
    payload
  );
  return data?.data ?? data;
}

export async function reviewInvestmentAttachment(attachmentId, { status, comment }) {
  const data = await payrollService.reviewInvestmentAttachment(attachmentId, {
    status,
    comment,
  });
  return data?.data ?? data;
}

export async function deleteInvestmentAttachment(attachmentId) {
  const data = await payrollService.deleteInvestmentAttachment(attachmentId);
  return data?.data ?? data;
}

export async function getInvestmentAttachmentUrl(attachmentId) {
  const data = await payrollService.getInvestmentAttachmentUrl(attachmentId);
  // backend returns { success, data: { url } }
  if (data?.data?.url) return data.data.url;
  return data?.url ?? null;
}

export async function getInvestmentAttachmentDownloadUrl(attachmentId) {
  const data = await payrollService.getInvestmentAttachmentDownloadUrl(attachmentId);
  // backend returns { success, data: { url } }
  if (data?.data?.url) return data.data.url;
  return data?.url ?? null;
}
